import "@assets/css/main_style.css";

import PlataformaClickPlus from "PlataformaClickPlus";


//* Configuración para React 17
// import React from "react";
// import ReactDOM from "react-dom";

// ReactDOM.render(
// 	//<React.StrictMode>
// 		<PlataformaClickPlus />,
// 	//</React.StrictMode>,
// 	document.getElementById("root")
// );

//* Configuración para React 18
import React from "react";
import ReactDOM from "react-dom/client";
import i18n from "i18next";
import { initReactI18next, useTranslation } from "react-i18next";
import I18nextBrowserLanguageDetector from "i18next-browser-languagedetector";
import { es } from "@helpers/idiomas/es";
import { en } from "@helpers/idiomas/en";

const root = ReactDOM.createRoot(document.getElementById("root"));

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(I18nextBrowserLanguageDetector)
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
            translation: en
      },
      es: {
          translation: es
      }
    },
    fallbackLng: 'es',
    detection: {
        order: ['localStorage', 'navigator', 'htmlTag']
    },

    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });


root.render(<PlataformaClickPlus />);
